export const COLUMN_PROMOTION = [
  {
    label: 'Code',
    stateValue: 'code',
  },
  {
    label: 'Name',
    stateValue: 'name',
  },
  {
    label: 'Quota',
    stateValue: 'quota',
  },
  {
    label: 'Total Used',
    stateValue: 'totalUsed',
    width: 72,
  },
  {
    label: 'Description',
    stateValue: 'description',
    width: 200,
  },
  {
    label: 'Start Date',
    stateValue: 'startDate',
  },
  {
    label: 'End Date',
    stateValue: 'endDate',
  },
  {
    label: 'Action',
    stateValue: 'action',
  },
];

export const TYPE_MODAL = {
  Edit: 'Edit',
  Create: 'Create',
};
